function LoginsCtrl($scope, $timeout, $state, $controller, DevicesService, GeneralUtilsService, GeneralPropertiesService) {
	$controller('ConfigController', { $scope: $scope, $timeout: $timeout });

	$scope.datamodified = false;
	$scope.dnssettingsdatamodified = false;
	$scope.groupsDataModified = false;
    $scope.proxyFileConfigProperties={};

	$scope.phoneConfig = {};
	$scope.phoneConfig.phoneConfigChanged = false;
	$scope.deviceCategory = DevicesService.getDeviceCategories();
	$scope.os = DevicesService.getOs();



    // stating that client side validations has failed
	var nonValidInput = false;

    /**
     * callback when phone validation has failed stating that one of the inputs found on the phone directive
     * has a value which is not valid
     */
	$scope.phoneValidationViolation = function () {
		nonValidInput = true;
	};

    /**
     * callback for the phone number which was changed by the user on the phone directive
     * if this callback was triggered the received number is a valid number
     * @param number - the new number
     */
    $scope.setPhoneNumber = function(number){
        nonValidInput = false;
        $scope.phoneConfig.phoneNumber = number;
        if(typeof $scope.accesslogin.phoneNumber != 'undefined')
            $scope.phoneConfig.phoneConfigChanged = true;
        else
            $scope.phoneConfig.phoneConfigChanged = $scope.accesslogin.phoneNumber != $scope.phoneConfig.phoneNumber;
    };


	$scope.$root.hasChanges = function () {
		if (!nonValidInput) {
			var accesslogin = $scope.accesslogin;
			if (!accesslogin) return false;
			if (accesslogin.id < 0) return true; // new access login
            var hasProxyFileConfigChanged = false;
            if($scope.proxyFileConfigProperties.hasChanges){
                hasProxyFileConfigChanged = $scope.proxyFileConfigProperties.hasChanges();
            }

			if (!angular.equals($scope.accesslogin, $scope.orig)) return true;

            // if phone changed or proxyFileConfig
			if ($scope.phoneConfig.phoneConfigChanged  || hasProxyFileConfigChanged) {
				return true;
			}
		}
		return false;
	};


	$scope.resendInvitations = function (selectedItems, type) {
		var items = [];
		var nameList = [];
		var disabledNameList = [];
		selectedItems.forEach(function (item) {
			items.push(item.id);
			nameList.push(item.name);
			if (item.status == "DISABLED"){
			    disabledNameList.push(item.name);
			}
		});
		var data = { items: items, type: type };
		var len = selectedItems.length;
		if (len == 0) {
			$scope.$root.alert('Please select users');
			return;
		}else if (disabledNameList.length != 0) {
            var suffix = disabledNameList.length > 1 ? 's' : '';
            $scope.$root.alert('Unselect the following disabled user' + suffix + ' before resending invitation' + suffix + ": " + disabledNameList.join(', '));
            return;
        }

		var itemsMessage = (len === 1 ? 'invitation to one user: ' : len + ' invitations to selected users: ') + nameList.join(', ');
		$scope.$root.confirm('Resending the VPN invitation resets the account for VPN users, ' +
			'and they must follow the instructions in the invitation before they can connect to the VPN.\n' +
			'\n' +
			'Do you want to continue and resend the ' + itemsMessage + '?', function () {
			store.action({
				path: 'resendMail',
				data: data,
				dataObj: 'json',
				success: function (responseData) {
					$scope.$root.handleServerResponse(responseData, '', 'Invitations were sent to the selected users', null, true);
				},
			});
		});
	};

	$scope.activateUsers = function (selectedItems, type){
		var items = [];
		var nameList = [];
		var activeUsers = [];
		selectedItems.forEach(function (item) {
			items.push(item.id);
			nameList.push(item.name);
			if (item.status !== "PENDING_USER_CONFIGURATION"){
				activeUsers.push(item.name);
			}
		});
		var data = { items: items, type: type };
		var selectedLength = selectedItems.length;
		if (selectedLength === 0) {
			$scope.$root.alert('Please select users');
			return;
		} else if (activeUsers.length !== 0) {
			var suffix = activeUsers.length > 1 ? 's' : '';
			$scope.$root.alert('Some of the selected users are not pending configuration. Unselect the following ' + suffix + ' before activating' + suffix + ": " + activeUsers.join(', '));
			return;
		}

		var itemsMessage = (selectedLength === 1 ? 'one user: ' : selectedLength + ' the selected users: ') + nameList.join(', ');
		$scope.$root.confirm('Are you sure you want to activate ' + itemsMessage + '?', function () {
			store.action({
				path: 'activateUsers',
				data: data,
				dataObj: 'json',
				success: function (responseData) {
					$scope.$root.handleServerResponse(responseData, '', 'Selected users were activated', null, true);
				},
			});
		});
	};


	$scope.generateRegCodesForUsers = function (selectedItems) {
        var items = [];
        var nameList = [];
        var disabledNameList = [];
        selectedItems.forEach(function (item) {
            items.push(item.id);
            nameList.push(item.name);
            if (item.status == "DISABLED"){
                disabledNameList.push(item.name);
            }
        });
        var data = { items: items, accountId: $state.params.accountId };
        var len = selectedItems.length;
        if (len == 0) {
            $scope.$root.alert('Please select users');
            return;
        }else if (disabledNameList.length != 0) {
            var suffix = disabledNameList.length > 1 ? 's' : '';
            $scope.$root.alert('Unselect the following disabled user' + suffix + ' before generating registration codes ' + disabledNameList.join(', '));
            return;
        }

        var itemsMessage = (len == 1 ? 'to one user: ' : 'to ' + len + ' selected users: ') + nameList.join(', ');
        $scope.$root.confirm('Are you sure you want to generate registration codes ' + itemsMessage + '?', function () {
            store.action({
                path: 'generateRegCodesForUsers',
                data: data,
                dataObj: 'json',
                success: function (data) {
                    $scope.$root.handleServerResponse(data, '', 'Generated Codes for users', null, true);
                }
            });
        });
    };

	$scope.resetPasswordOrSecret = function (selectedItems, type, resetType) {
		var items = [];
		var nameList = [];
        var disabledNameList = [];
		selectedItems.forEach(function (item) {
			items.push(item.id);
			nameList.push(item.name);
            if (item.status == "DISABLED"){
                disabledNameList.push(item.name);
            }
		});
		var data = { items: items, type: type, accountId: $state.params.accountId };
		var len = selectedItems.length;
		if (len == 0) {
			$scope.$root.alert('Please select users');
			return;
		}else if (disabledNameList.length != 0) {
            var suffix = disabledNameList.length > 1 ? 's' : '';
            $scope.$root.alert('Unselect the following disabled user' + suffix + ' before reset ' + (resetType === 'secret' ? 'secret: ' : 'password: ') + disabledNameList.join(', '));
            return;
        }

		var itemsMessage = (len == 1 ? 'to one user: ' : 'to ' + len + ' selected users: ') + nameList.join(', ');
		$scope.$root.confirm('Are you sure you want to reset ' + (resetType === 'secret' ? 'secret ' : 'password ') + itemsMessage + '?', function () {
			store.action({
				path: resetType === 'secret' ? 'resetSecrets' : 'resetPasswords',
				data: data,
				dataObj: 'json',
				success: function (data) {
					$scope.$root.handleServerResponse(data, '', (resetType === 'secret' ? 'Secrets' : 'Passwords') + ' were reset', null, true);
				},
			});
		});
	};

	$scope.unLock = function () {
		$scope.$root.confirm('Are you sure you want to unlock user ' + $scope.accesslogin.firstName + '  ' + $scope.accesslogin.lastName + ' ?', function () {
			store.action({
				path: 'unlockUser',
				queryParams: { accessloginId: $scope.accesslogin.id },
				success: function (data) {
					$scope.$root.handleServerResponse(data, '', 'User is unlocked');
					if (data.status !== 'ERROR') {
						$scope.reloadUser(data);
					}
				},
			});
		});
	};

	function allowNewUsers() {
		store.fetch({
			path: '/allowNewUsers?accountId=' + $state.params.accountId,
			success: function (data) {
				$scope.availableUserLicenses = data;
			},
		});
	}

    /**
     * setting default values to properties on the controller to the
     * preliminary values
     */
    function resetAccessLogin() {
        nonValidInput = false;
        $scope.phoneConfig.phoneConfigChanged = false;
        $scope.phoneConfig.phoneNumber = "";
    }

	$scope.tableConfig = {
	    hasChanges: $scope.$root.hasChanges,
		noAutoCheckboxSelect: true,
		mode: 'list',
        pageSize: 50,
		statusNames: { DISABLED: 'Disabled', ACTIVE: 'Configured', LOCKED: 'Locked', NEW: 'New', PENDING_USER_CONFIGURATION: 'Invitation Sent', PENDING_MFA_CONFIGURATION: 'MFA invitation Sent', PENDING_CODE_GENERATION: 'Requires new code' },
		loginNameById: {},
		dataURL: function () {
			return '/getAllLogins?accountId=' + ($state.params.accountId ? $state.params.accountId : '');
		},
		processData: function (items) {
			allowNewUsers();
			items.forEach(function(item) {
			    if (item.prefix)
			        item.caption = item.prefix + item.name;
			});
		},
		titleSearch: 'VPN Users',
		accountId: $state.params.accountId,
		batchAddURL: function () {
			return '/batchUpload?type=AccessLogin&parent=logins&accountId=' + $state.params.accountId;
		},
		height: $scope.getContentHeight(),
		sortButton: true,
		afterUpdate: function () {
			if ($scope.$root) {
				$scope.$root.updateScroll('.pane.left .nano');
			}
			allowNewUsers();
		},
		searchId: $state.params.id, // in case there is a search value in the URL params, use it to search
		searchFields: ['email'],
		fields: [{ label: 'Name', path: 'name', template: '<span>{{item.prefix}}{{item.name}}</span>' },
            { label: 'E-mail', path: 'email' },
            { label: 'Status', path: 'status', template: "<span><span ng-show='item.status == \"LOCKED\"' class='glyphicon glyphicon-lock error'></span> {{tableConfig.statusNames[item.status]}}</span>" },
            { label: 'Origin', path: 'importType', template: "<span>{{item.importType == 'LDAP'?'LDAP defined':'User defined'}}</span>" },
            { label: 'Creation Date', path: 'creationDate' },
            { label: 'Last Modified', path: 'lastModified' }, /* ,
             {"label": "", "template": '<img src="/public/images/connectivity.png" style="cursor:' +
             ' pointer;" data-toggle="modal" data-target="#myModal" data-type="login" data-id="{{item.id}}"></img>'}*/
		],
		type: 'AccessLogin',
		addAction: function (type) {
			var that = this;
			if (typeof $scope.availableUserLicenses === 'undefined') {
				$timeout(function () {
					that.addAction(type);
				}, 100, false);
			} else {
				that.addNew(type);
			}
		},
		addNew: function () {
			if ($scope.availableUserLicenses.allowNew) {
		  		$scope.newLogin = { id: GeneralUtilsService.getRandomId(), name: '', status: 'NEW'  };
				$scope.$root.openPopup('addLoginDlg');
			} else if($scope.availableUserLicenses.isDisable){
				$scope.$root.alert("Account license is Disable, please contact reseller for purchasing new license.");
			} else {
				$scope.$root.alert('There are no available licenses for new VPN users. Contact your reseller for purchasing new licenses.');
			}
		},
		actions: ['remove'],
		specialActions: [
			{
				func: function (selectedItems) {
					$scope.disable(selectedItems, 'AccessLogin', null, function(){
					    allowNewUsers();
					});
				},
				icon: 'disable',
				tooltip: 'Disable Users'
			},
			{
				func: function (selectedItems) {
					$scope.disable(selectedItems, 'AccessLogin', true, function(){
                        allowNewUsers();
                    });
                },
				icon: 'enable',
				tooltip: 'Enable Users'
			},
			{
				func: function (selectedItems) {
					$scope.resendInvitations(selectedItems, 'AccessLogin');
				},
				icon: 'retweet',
				tooltip: 'Resend invitations'
			},
			{
				func: function (selectedItems) {
					$scope.activateUsers(selectedItems, 'AccessLogin');
				},
				icon: 'retweet',
				tooltip: 'Activate'
			},
			{
				func: function (selectedItems) {
					$scope.generateRegCodesForUsers(selectedItems);
				},
				icon: '',
				tooltip: 'Generate Registration Code'
			},
			{
				func: function (selectedItems) {
					$scope.resetPasswordOrSecret(selectedItems, 'AccessLogin', 'password');
				},
				icon: 'password',
				tooltip: 'Reset Passwords'
			},
			{
				func: function (selectedItems) {
					$scope.resetPasswordOrSecret(selectedItems, 'AccessLogin', 'secret');
				},
				icon: '',
				tooltip: 'Reset 2 Factor Authentication'
			},
		],
		onSelect: function (index) {
		    $scope.selectedLoginIndex = index;
			store.fetch({
				path: '/show?type=accesslogin&accessloginId=' + $scope.tableConfig.items[index].id + '&loadExtraData=MFA_SETTINGS,DEVICE_AUTHENTICATION',
				success: function (data) {
					resetAccessLogin();
					if (!$scope.loaded) {
						return;
					}

                    $scope.$root.clearErrors();

                    //will be added by the general-property component itself
                    delete data.generalProperties;
                    data.isGeneralPropertiesUpdated = false;

                    $scope.accesslogin = data;

                    $scope.orig = angular.copy($scope.accesslogin);
                    $scope.proxyFileConfigProperties.entity = $scope.accesslogin;
                    $scope.proxyFileConfigProperties.orig = $scope.orig;

                    $scope.devicesTableModified = new Date().getTime();
                    $scope.dnssettingsdatamodified = new Date().getTime();

                    $scope.groupsDataModified = new Date().getTime();

                    $scope.updateRightScroll();

                    if($scope.accesslogin.phoneNumber){
                        $scope.phoneConfig.phoneNumber = $scope.accesslogin.phoneNumber;
                    }
                    $scope.$digest();
                    $scope.$broadcast('modelReloadedEvent');
                    $scope.$broadcast('reset-properties');

                    updateDevicesTable($scope.accesslogin);
				},
			});
		},
	};

	function init() {
        if (!$scope.$root || !$scope.$root.tags) {
            $timeout(function() {
                init(true);
            }, 20, false);
            return;
        }

		getAccountDevicePostureStatus();
    }

    init();

    // listener fo changes in the general properties, properties field sent to this function is the diff after equal check
    $scope.generalPropertiesChanged = function (properties, isGeneralPropertiesUpdated) {
        if (isGeneralPropertiesUpdated){
            $scope.generalPropertiesToSave = properties;
        }
        $scope.accesslogin.isGeneralPropertiesUpdated = isGeneralPropertiesUpdated;
    }

    //disable actions on user devices if MFA is not enabled on user
	function updateDevicesTable(accesslogin){
	    $scope.devicesTable.actionsDisabled = accesslogin.isMfaEnabledForUser ? false: true;
	}

     // set scope param to
	if (isSystemLogin) {
		$scope.isSystemLogin = true;
		$scope.tableConfig.specialActions.push({ func: function (selectedItems) {
			$scope.configDebugMode(selectedItems, 'AccessLogin', 1);
		},
			icon: 'debugMode',
			tooltip: 'Extend Debug Mode' });

		$scope.tableConfig.specialActions.push({ func: function (selectedItems) {
			$scope.configDebugMode(selectedItems, 'AccessLogin', 0);
		},
			icon: 'debugMode',
			tooltip: 'Disable Debug Mode' });

	}

	function setStatus(items, set, setTo) {
		if (items && items.length > 0) {
			items.forEach(function (item) {
				if (set) {
					item.isActive = setTo;
				}				else {
					item.isActive = (item.status === 'ACTIVE');
				}
			});
		}
	}


    /**
     * update the phone number if user inserted one
     */
    function updatePhoneNumber() {
        if (typeof $scope.phoneConfig.phoneNumber != 'undefined') {
            $scope.accesslogin.phoneNumber = $scope.phoneConfig.phoneNumber;
        }
    }

	$scope.saveChanges = function () {
        if ($scope.accesslogin.isGeneralPropertiesUpdated){
            $scope.accesslogin.generalProperties = $scope.generalPropertiesToSave;
		}

		// had to add AllowIndirectRemovals annotation (cascade problem) - but when this annotation is added delete of subItems are done according to comparing list
		// which mean deleting subItems from other pages, to avoid unwanted removals added a check if item is part of delete map - also if there are no deleted items
		// todo: Added here as a copy from sitesCtrl. All of this logic should be improved.
		if (!$scope.accesslogin.itemsToDelete){
            $scope.accesslogin.itemsToDelete = {};
        }
        if (!$scope.accesslogin.itemsToDelete.generalProperties){
            $scope.accesslogin.itemsToDelete.generalProperties = [];
        }

		updatePhoneNumber();
		$scope.accesslogin.newSaveMethod = true;
		$scope.loading = true;
		store.save({
			path: '/edit',
			data: $scope.accesslogin,
			dataObj: 'json',
			queryParams: { accessloginId: $scope.accesslogin.id, save: true, loadExtraData:'MFA_SETTINGS' },
			success: function (data) {
				$timeout(function() {
					$scope.loading = false;
				}, 0);

				$scope.$root.handleServerResponse(data, 'accesslogin', 'User saved successfully');
				$scope.dnssettingsdatamodified = new Date().getTime();
				if (data.status !== 'ERROR') {
					$scope.reloadUser(data.model, true);
				}
			},
		});
	};

	$scope.reloadUser = function (data, updateTableItem) {
	    data.isGeneralPropertiesUpdated = false;
		$scope.accesslogin = data;
        $scope.proxyFileConfigProperties.entity = $scope.accesslogin;
        $scope.proxyFileConfigProperties.orig = $scope.orig;
		$scope.tableConfig.selectedId = data.id;
		$scope.phoneConfig.phoneConfigChanged = false;

		if (updateTableItem) {
			var i;
			for (i = 0;$scope.tableConfig.items[i];i++) {
				if ($scope.tableConfig.items[i].id === data.id) {
					break;
				}
			}
			$scope.tableConfig.items[i] = data;

			if(data.prefix){
    			$scope.tableConfig.items[i].caption = data.prefix + data.name;
			}
			$scope.orig = angular.copy($scope.accesslogin);
		}

		$scope.$broadcast('modelReloadedEvent');
		$scope.$digest();
		$scope.$broadcast('reset-properties');
	};


	$scope.addLogin = function () {
		$scope.loadingSaveNew = true;
		var params = { accountId: $state.params.accountId, type: 'AccessLogin', save: true};
		store.save({
			path: '/add',
			data: $scope.newLogin,
			dataObj: 'json',
			queryParams: params,
			success: function (data) {
			    allowNewUsers();
				$scope.loadingSaveNew = false;
				$scope.$root.handleServerResponse(data, 'newLogin', 'User added successfully');
				if (data.status !== 'ERROR') {
					$scope.tableConfig.selectedId = data.model.id;
					$scope.datamodified = new Date().getTime();
					$scope.$root.closePopup('addLoginDlg');
				}
			},
		});
	};


	$scope.devicesTable = {
		dataURL: function () {
			return '/getDevices?accountId=' + ($state.params.accountId ? $state.params.accountId : '') + '&accessloginId=' + $scope.accesslogin.id;
		},
		defer: true,
		titleSearch: 'Users',
		clientSideSearch: true,
		clientSideSort: true,
		pageSize: -1,
		afterUpdate: function () {
		},
		deviceCategory: $scope.deviceCategory,
		osTypes: $scope.os,
		fields: [
			{ label: 'Name', path: 'name', template: '{{item.name}}' },
			{ label: 'Type', path: 'type', template: '{{tableConfig.deviceCategory[item.category]}}' },
			{ label: 'OS', path: 'osType', template: '{{tableConfig.osTypes[item.osType]}} {{item.osVersion}}' },
			{ label: 'Identifier', path: 'identifier', template: '{{item.identifier}}' },
			{ label: 'Client Version', path: 'versionName', template: '<span>{{item.versionName}}</span>' },
			{ label: 'Release Group', path: 'releaseGroup', template: '<span>{{item.releaseGroup}}</span>' },
			{ label: 'Last Session Info', template: '{{item.location["city"]}}, {{item.location["region"]}}, {{item.location["country_long"]}} - {{item.isConnected ? "Connected" : item.lastSeenAgo + " ago"}}' },
			{ label: 'Status', path: 'status', template: "<span ng-show='item.status === \"REVOKED\"'>{{item.status}}</span>" },
		],
		type: 'Device',
		processData: function (items) {
			if (items) {
				items.forEach(function (item) {
					if (item.lastSeen) {
						item.lastSeenAgo = moment.duration(new Date().getTime() - (item.lastSeen * 1000)).humanize();
					}
				});
			}

			return items;
		},
		actions: [],
		specialActions: [
			{
				func: function (selectedItems) {
					var deviceIds = [];
					selectedItems.forEach(function (item){
						deviceIds.push(item.deviceId);
					});
					$scope.revoke(deviceIds);
				},
				icon: 'delete',
				tooltip: 'Revoke Device',
			}
		],
		noAutoSelect: true,
	};

	$scope.revoke = function (deviceIds) {
		store.action({
			path: '/revokeDevice?accessloginId=' + $scope.accesslogin.id,
			data: deviceIds,
			dataObj: 'json',
			success: function (data) {
				$scope.$root.handleServerResponse(data, 'accesslogin', 'Devices mfa authorization revoked successfully');
				if (data.status !== 'ERROR') {
					$scope.devicesTableModified = new Date().getTime();
				}
			},
		});
	};

    //adds the deleted general properties from the general properties component to accesslogin deleted items list
	$scope.addDeletedGeneralProperties = function (properties) {
        if (properties.length > 0) {
                if (!$scope.accesslogin.itemsToDelete) {
                        $scope.accesslogin.itemsToDelete = {};
                            }
                    $scope.accesslogin.itemsToDelete.generalProperties = ($scope.accesslogin.itemsToDelete.generalProperties && $scope.accesslogin.itemsToDelete.generalProperties.length > 0) ?
                                                                      properties.concat($scope.accesslogin.itemsToDelete.generalProperties) : properties;
                                            }
        }

	function getAccountDevicePostureStatus() {
		if ($scope.$root.tags.includes('DEVICE_POSTURE_POC')) {
			store.fetch({
				path: '/getAccountDevicePostureStatus?accountId=' + $state.params.accountId,
				success: function (data) {
					$scope.accountDevicePosture = data;
				},
			});
		}
	}
}

